module.exports = __webpack_public_path__ + "static/travelworld_icons-7c334ebe9331935cb11f6fbc915847cc.svg";